<template>
  <div class="flex h-14 w-full flex-row items-center justify-end gap-1 px-4">
    <BaseTextButton size="XS" @click="logout" shape="square" class="text-on-surface-variant!">{{
      $t('app.logout')
    }}</BaseTextButton>
    <BaseMenu v-if="items.length > 1" :items="items" v-slot="{ open }">
      <BaseTextButton
        color="outlined"
        shape="square"
        trailing-icon="arrow_drop_down"
        size="XS"
        :force-pressed="open"
        >{{ $t('organization.switch') }}</BaseTextButton
      >
    </BaseMenu>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useRouter } from 'vue-router'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseMenu from '@/core/components/base/menu/BaseMenu.vue'
  import { useOrganizationStore } from '@/stores/organization.store.ts'
  import { useAuthStore } from '@/stores/auth.store.ts'

  const organizationStore = useOrganizationStore()
  const authStore = useAuthStore()
  const router = useRouter()

  const items = computed(() =>
    organizationStore.organizations.map((organization) => ({
      id: organization.id,
      title: organization.name,
      icon: 'check',
      callback: () => {
        router.replace('/')
        router.go(0)
        organizationStore.switchOrganization(organization.id)
      },
    })),
  )

  const logout = () => {
    authStore.logout()
  }
</script>
